import { z } from 'zod';

export const CateringEventCategoryModelSchema = z.object({
    uid: z.string(),
    name: z.string(),
    slug: z.string(),
});

export type CateringEventCategoryModel = z.infer<typeof CateringEventCategoryModelSchema>;
